// http://lbs.tianditu.gov.cn/

// http://api.tianditu.gov.cn/api?v=4.0&tk=您的密钥

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace T {
  class Map {
    constructor(name: string | HTMLElement);
    centerAndZoom(lngLat: LngLat, zoom: number): Map;
    setStyle(style: "indigo" | "black"): Map;
    removeStyle(): Map;
  }
  class LngLat {
    constructor(lng: number, lat: number);
  }
}

export class mapTDTJSSDK {
  map: T.Map;

  constructor(
    container: string | HTMLElement,
    mapCenterLng = 120.619585,
    mapCenterLat = 31.299379,
    mapZoom = 18
  ) {
    this.map = new T.Map(container);
    this.map.centerAndZoom(new T.LngLat(mapCenterLng, mapCenterLat), mapZoom);
  }
}
export default mapTDTJSSDK;
